import VueRouter from "vue-router"
import home from '../../src/views/Login/login.vue'

const router = new VueRouter({
  routes: [
    //配置路由的路径
    {
      path: '',
      redirect:'/zhicheng'
    },
    {
      path: '/zhicheng',
      component: home,
      meta: {
        title: '智步云上-智呈可视化工具解决方案'
      }
    },
    {
      path: "*",
      name: "NotFound",
      component: () => import("../views/Error/404.vue"),
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
export default router;